import { FC, useCallback, useEffect, useMemo, useState } from 'react';

import { Options } from 'react-select';
import CreatableSelect from 'react-select/creatable';

import classnames from 'classnames';

import { Option } from '@hsp/react-component-library/types';
import { formatMoney, isDefined, isEmpty, isNumber } from '@hsp/utilities';

import { onCreateOptions } from 'pages/audience/shared';
import { ITagSelectionDataPointProps } from 'types/pages/audience-builder/components';
import { s } from 'utilities/strings';

import './donation.component.scss';

const DonationLow: FC<ITagSelectionDataPointProps> = ({
  className,
  data,
  isInvalid = false,
  onValueChanged,
  value,
}) => {
  const { values } = data;
  const options = useMemo(() => {
    if (Array.isArray(values)) {
      return values.map((value) => {
        return {
          label: formatMoney(value, 0),
          value: value.toString(),
        };
      });
    }

    return [];
  }, [values]);
  const [donationLow, setDonationLow] = useState<Options<Option<string>>>(options);
  const handleCreateLow = useCallback((value: string) => onCreateOptions(value, setDonationLow), []);

  useEffect(() => {
    if (!isDefined(value) || isEmpty(value)) {
      return;
    }

    const item = donationLow.find(({ value: itemValue }) => itemValue === value);

    if (!isDefined(item)) {
      handleCreateLow(value.toString());
    }
  }, [donationLow, handleCreateLow, value]);

  return (
    <div className={classnames('rfm-donation-wrapper', className, { 'is-invalid': isInvalid })}>
      <CreatableSelect
        createOptionPosition="first"
        menuPlacement="auto"
        onChange={(option) => {
          onValueChanged?.(option?.value);
        }}
        onCreateOption={(controlValue) => {
          if (isNumber(controlValue)) {
            handleCreateLow(controlValue);
            onValueChanged?.(controlValue);
          }
        }}
        options={donationLow}
        placeholder={s('Site.Low')}
        value={donationLow.find((option) => option.value === value) ?? null}
      />
    </div>
  );
};

export default DonationLow;
